import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function InfoIcon({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 13 13" width={size} {...props}>
      <Path
        d="M6.5 12.5C9.8136 12.5 12.5 9.8136 12.5 6.5C12.5 3.1864 9.8136 0.5 6.5 0.5C3.1864 0.5 0.5 3.1864 0.5 6.5C0.5 9.8136 3.1864 12.5 6.5 12.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.6748 9.59912H7.2748C7.06263 9.59912 6.85915 9.49376 6.70912 9.30623C6.55909 9.11869 6.4748 8.86434 6.4748 8.59912V6.09912C6.4748 5.96651 6.43266 5.83934 6.35765 5.74557C6.28263 5.6518 6.18089 5.59912 6.0748 5.59912H5.6748"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle cx="6.1252" cy="3.74385" fill={color} r="0.8" />
    </Svg>
  );
});
